/* src/app/modules/home/components/set-additional-info/set-additional-info.component.scss */
.add-info {
  padding-bottom: 2rem;
}
.add-info .block-label {
  margin: 0.625rem 3.125rem;
  text-align: left;
  font-weight: var(--font-weight-normal);
}
.add-info .request-text {
  margin: 0 3.125rem;
  height: 20.625rem;
  overflow-y: auto;
  border: 0.063rem solid lightgray;
  border-radius: 0.313rem;
  padding: 0.625rem;
  text-align: left;
}
.add-info .request-text .message {
  display: inline-block;
  width: 80%;
  padding: 0.625rem;
  margin: 0.625rem 0;
  border-radius: 0.313rem;
  background-color: lightgoldenrodyellow;
}
.add-info .request-text .message.my-message {
  float: right;
  background-color: lightcyan;
}
.add-info .request-text .message .text {
  margin-right: 1.25rem;
}
.add-info .request-text .message .doc-icon {
  float: right;
  margin-top: -0.938rem;
}
.add-info .request-text .message .doc-icon .icon ods-icon {
  height: 1.7rem;
  width: 1.7rem;
  display: inline-block;
  background-size: contain;
  background-repeat: no-repeat;
}
.add-info .request-text .message .heading {
  margin-bottom: 0.438rem;
  font-size: 0.75rem;
  font-weight: var(--font-weight-book);
}
.add-info .request-text .message .heading span {
  color: var(--brand-50);
  font-weight: var(--font-weight-normal);
}
.add-info .divider {
  height: 0.125rem;
  width: 100%;
  background-color: var(--black);
  margin: 0.625rem 0;
}
.add-info .upload-block {
  margin: 0.625rem 3.125rem 1.875rem;
}
.add-info .upload-block .flex {
  display: flex;
  align-items: center;
}
.add-info .upload-block .flex .fileName {
  margin-left: 0.625rem;
}
.add-info .upload-block .flex .upload {
  display: inline-block;
  cursor: pointer;
  position: relative;
  text-align: center;
}
.add-info .upload-block .flex .upload-hidden {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  opacity: 0;
  cursor: pointer;
}
.add-info .upload-block .flex .upload .explanatory {
  text-transform: none;
  font-size: 0.75rem;
  color: var(--negative-3);
}
.add-info .error {
  text-align: right;
  color: var(--negative-3);
  width: calc(100% - 6.25rem);
  margin: 0 auto;
}
.add-info .upload-block .upload .error {
  text-align: left;
  width: 100%;
  text-transform: none;
}
.add-info ods-text-area {
  width: calc(100% - 6.25rem);
  font-size: 1.125rem;
  font-weight: var(--font-weight-book);
  margin: 0.625rem 3.125rem;
}
.add-info .btn-container {
  margin: 0.625rem 3.125rem;
}
.add-info .btn-container .submit-btn-box {
  float: right;
  padding-left: 10px;
}
.add-info ods-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--white);
  height: 1.7rem;
  width: 1.7rem;
  margin: 0.5rem;
}
/*# sourceMappingURL=set-additional-info.component.css.map */
